"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDisplayFormMetadata = void 0;
var tslib_1 = require("tslib");
var catalogSelectors_1 = require("../store/catalog/catalogSelectors");
var effects_1 = require("redux-saga/effects");
var objRefMap_1 = require("../../_staging/metadata/objRefMap");
function loadDisplayFormsMetadata(ctx, refs) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (!refs.length) {
                return [2 /*return*/, []];
            }
            return [2 /*return*/, ctx.backend.workspace(ctx.workspace).attributes().getAttributeDisplayForms(refs)];
        });
    });
}
/**
 * Given a set of display form refs (which may be of any type.. uri or id), this function returns a list of
 * attribute display form metadata objects.
 *
 * @param ctx - dashboard context in which the resolution is done
 * @param refs - ObjRefs of display forms; the type of ObjRef can be either uri or id ref, the function will resolve it regardless
 * @param displayForms - specify mapping of display forms to use for in-memory resolution of refs to metadata objects; if
 *  not specified, the generator will retrieve all catalog display forms from state
 */
function resolveDisplayFormMetadata(ctx, refs, displayForms) {
    var catalogDisplayForms, _a, resolvedDisplayForms, tryLoadDisplayForms, loadedDisplayForms, loadedDisplayFormsMap, missing;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!displayForms) return [3 /*break*/, 1];
                _a = displayForms;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, effects_1.select(catalogSelectors_1.selectAllCatalogDisplayFormsMap)];
            case 2:
                _a = _b.sent();
                _b.label = 3;
            case 3:
                catalogDisplayForms = _a;
                resolvedDisplayForms = [];
                tryLoadDisplayForms = [];
                refs.forEach(function (ref) {
                    var catalogDisplayForm = catalogDisplayForms.get(ref);
                    if (catalogDisplayForm) {
                        resolvedDisplayForms.push(catalogDisplayForm);
                    }
                    else {
                        tryLoadDisplayForms.push(ref);
                    }
                });
                return [4 /*yield*/, effects_1.call(loadDisplayFormsMetadata, ctx, tryLoadDisplayForms)];
            case 4:
                loadedDisplayForms = _b.sent();
                loadedDisplayFormsMap = objRefMap_1.newDisplayFormMap(loadedDisplayForms);
                missing = [];
                tryLoadDisplayForms.forEach(function (ref) {
                    var loadedDisplayForm = loadedDisplayFormsMap.get(ref);
                    if (loadedDisplayForm) {
                        resolvedDisplayForms.push(loadedDisplayForm);
                    }
                    else {
                        missing.push(ref);
                    }
                });
                return [2 /*return*/, {
                        resolved: objRefMap_1.newDisplayFormMap(resolvedDisplayForms),
                        missing: missing,
                    }];
        }
    });
}
exports.resolveDisplayFormMetadata = resolveDisplayFormMetadata;
//# sourceMappingURL=displayFormResolver.js.map